var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#DBDBDB"
    },
    points: "72,213.6 248,45.6 424,213.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M496,463.2c0,9.6-8,16.8-16,16.8H16c-8.8,0-16-7.2-16-16.8v-208C0,244.8,8,240,16,240h464 c8.8,0,16,4.8,16,14.4V463.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M480,240H248v240h232c8.8,0,16-7.2,16-16.8v-208C496,244.8,488,240,480,240z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M24.8,235.2L24.8,235.2c0-12,9.6-22.4,22.4-22.4l0,0c12,0,22.4,9.6,22.4,22.4l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M427.2,235.2L427.2,235.2c0-12,9.6-22.4,22.4-22.4l0,0c12,0,22.4,9.6,22.4,22.4l0,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M141.6,357.6c0,30.4-18.4,46.4-40.8,46.4c-23.2,0-39.2-17.6-39.2-44.8c0-28,17.6-46.4,40.8-46.4 C126.4,313.6,141.6,332,141.6,357.6z M73.6,359.2c0,18.4,10.4,35.2,28,35.2s28-16.8,28-36.8c0-17.6-8.8-36-28-36 C83.2,323.2,73.6,340,73.6,359.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M183.2,316c5.6-0.8,12.8-1.6,21.6-1.6c11.2,0,19.2,2.4,24.8,7.2c4.8,4,8,10.4,8,18.4 s-2.4,14.4-6.4,18.4c-5.6,6.4-16,9.6-27.2,9.6c-3.2,0-6.4,0-8.8-0.8v35.2H184V316H183.2z M194.4,358.4c2.4,0.8,5.6,0.8,9.6,0.8 c13.6,0,22.4-6.4,22.4-18.4c0-11.2-8-16.8-20.8-16.8c-4.8,0-8.8,0-10.4,0.8v33.6H194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M324,361.6h-34.4v32H328v9.6h-49.6v-88h47.2v9.6h-36V352H324V361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M368,402.4v-88h12l28,44.8c6.4,10.4,11.2,19.2,16,28.8l0,0c0-12-0.8-22.4-0.8-36v-36.8h10.4v88 h-11.2l-28-44.8c-6.4-9.6-12-20-16.8-29.6l0,0c0.8,11.2,0.8,21.6,0.8,36v37.6L368,402.4L368,402.4z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F15249"
    },
    cx: 248,
    cy: 50.4,
    r: 34.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C93131"
    },
    d: "M272.8,25.6c13.6,13.6,13.6,35.2,0,48.8s-35.2,13.6-48.8,0"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSvgrepoCom);
export default __webpack_public_path__ + "static/media/open-svgrepo-com.9ce4cc3b4ae3edcab2e1b37fffc3435b.svg";
export { ForwardRef as ReactComponent };